<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I am the chip in your hardware',
        copy: 'I am the flow of energy for the things you watch. In the trenches, I fight for you in the cesspool of budget, bureaucracy and blow-hards. Everyone in my world wants something. I want the best. My appeal is undeniable when I am true to your vision. Make it amazing, passion-filled, unconstrained, open, and free… the best influences the rest. HDR. Honesty Delivered Robustly? High Dynamic Range! “Make it and they will come” begins when you are open to the…',
        lastword: 'POSSIBILITY',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/content-distributors.mp4',
        back_link: '/ce-manufacturers',
        forward_link: '/consumers',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.25'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $lt-green!important

</style>


/** WEBPACK FOOTER **
 ** ce-distributors.vue?793d328b
 **/